export const splitDecimal = (value: number | string) => {
  const [integer, decimal = '0'] = value.toString().split('.');
  return { integer: Number(integer), decimal: Number(decimal) };
};

export const splitDate = (value: string) => {
  const [date, time] = value.split('T');
  const ampm = Number(time.split(':')[0]) < 12 ? 'AM' : 'PM';
  return {
    date: date.split('-').reverse().join('/'),
    time: `${time} ${ampm}`,
  };
};

export const formatDateAndTime = (dateString: string) => {
  const dateObj = new Date(dateString);
  const formattedDate = dateObj.toLocaleDateString('en-IN').replace(/\//g, '-');

  const hours = dateObj.getHours();
  const minutes = dateObj.getMinutes();
  const seconds = dateObj.getSeconds();

  let time;
  if (hours === 0 && minutes === 0 && seconds === 0) {
    const systemTime = new Date();
    time = systemTime
      .toLocaleTimeString('en-IN', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
      .replace('am', 'AM')
      .replace('pm', 'PM');
  } else {
    time = dateObj
      .toLocaleTimeString('en-IN', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
      .replace('am', 'AM')
      .replace('pm', 'PM');
  }

  return { date: formattedDate, time };
};

export const splitValueFromString = (
  value: string,
  delimiter: string,
  position: number,
) => {
  const tempData = value?.split(` ${delimiter} `);
  return tempData[position];
};

export const formatedCount = (amount: number) => {
  return amount?.toLocaleString('en-IN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

export const encodeData = (data: string | null): string => {
  if (data === null || data == undefined) {
    return '';
  }
  return btoa(data);
};

export const decodeData = (encryptedData: string | null): string => {
  if (encryptedData === null || encryptedData == undefined) {
    return '';
  }
  return atob(encryptedData);
};

export const formatNumber = (value: number): string => {
  const num = value / 100000;
  if (num >= 100) {
    return Math.round(num / 100) + ' Cr';
  }
  return Math.round(num) + ' L';
};

export const extractDurationAndTimeframe = (periodLevel: string) => {
  if (typeof periodLevel !== 'string' || periodLevel.trim() === '') {
    return { duration: 'M', timeframe: '1' };
  }
  if (periodLevel === 'MAX') {
    return { duration: 'Y', timeframe: '200' };
  }
  const chars = periodLevel.split('');
  let index = -1;
  for (let i = 0; i < chars.length; i++) {
    if (!isNaN(Number(chars[i]))) {
      index = i;
      break;
    }
  }
  if (index === -1 || index === 0) {
    return { duration: 'M', timeframe: '1' };
  }
  const duration = periodLevel.substring(0, index);
  const timeframe = periodLevel.substring(index);
  return { duration, timeframe };
};

export const createCompanySlug = (value: string): string => {
  value = value.replace(/[^a-zA-Z0-9\s-]/g, ' ');
  value = value.trim().replace(/\s+/g, '-');
  value = value.replace(/--+/g, '-');
  return value.toLowerCase();
};
